import { useController, type FieldPath, type FieldValues } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface TextareaFieldProps<TFieldValues extends FieldValues> {
  name: FieldPath<TFieldValues>;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  className?: string;
  containerClassName?: string;
  labelClassName?: string;
}

export function TextareaField<TFieldValues extends FieldValues>({
  name,
  label,
  placeholder,
  disabled,
  rows = 3,
  className,
  containerClassName,
  labelClassName,
}: TextareaFieldProps<TFieldValues>) {
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues>({ name });

  return (
    <div className={containerClassName ?? 'space-y-1'}>
      <Label htmlFor={name} className={labelClassName}>
        {label}
      </Label>
      <Textarea
        {...field}
        id={name}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={[className, error ? 'border-destructive' : ''].filter(Boolean).join(' ')}
        value={field.value ?? ''}
      />
      {error && <p className="text-xs text-destructive">{error.message}</p>}
    </div>
  );
}
